<a [routerLink]="['/'] | localize" class="brand-logo" [class.inverse]="inverse" [attr.aria-label]="'404.back-to-main-page' | translate">
  <i *ngIf="!inverse" class="icon icon-logo-{{ currentLang }}"></i>
  <i *ngIf="inverse" class="icon icon-logo-blue"></i>
</a>
